var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 55,
    viewBox: "0 0 109 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.395 97.23C5.957 97.23 4.10933 96.563 2.852 95.229C1.61 93.895 0.989 92.0933 0.989 89.824C0.989 88.1987 1.24967 86.8033 1.771 85.638C2.30767 84.4573 3.12033 83.5527 4.209 82.924C5.29767 82.28 6.68533 81.958 8.372 81.958C9.23067 81.958 10.0127 82.027 10.718 82.165C11.4387 82.2877 12.1057 82.4563 12.719 82.671V84.856C12.1057 84.6107 11.4463 84.4267 10.741 84.304C10.051 84.166 9.32267 84.097 8.556 84.097C6.716 84.097 5.41267 84.5877 4.646 85.569C3.89467 86.5503 3.519 87.9687 3.519 89.824C3.519 91.5567 3.933 92.8753 4.761 93.78C5.589 94.6693 6.86933 95.114 8.602 95.114C9.30733 95.114 10.0127 95.0603 10.718 94.953C11.4387 94.8303 12.1133 94.6463 12.742 94.401V96.609C12.1287 96.8083 11.4617 96.9617 10.741 97.069C10.0357 97.1763 9.25367 97.23 8.395 97.23ZM19.7726 97V82.188H26.5806C28.2366 82.188 29.4403 82.6173 30.1916 83.476C30.9583 84.3193 31.3416 85.4693 31.3416 86.926C31.3416 87.9687 31.081 88.858 30.5596 89.594C30.0383 90.33 29.287 90.8437 28.3056 91.135C28.5816 91.3343 28.7963 91.549 28.9496 91.779C29.103 92.009 29.2563 92.3157 29.4096 92.699L31.2726 97H28.6966L26.8796 92.86C26.711 92.4613 26.504 92.1777 26.2586 92.009C26.0286 91.8403 25.63 91.756 25.0626 91.756H22.2796V97H19.7726ZM22.2796 89.732H25.9136C26.8183 89.732 27.5313 89.5097 28.0526 89.065C28.574 88.6203 28.8346 87.9073 28.8346 86.926C28.8346 85.0707 27.9376 84.143 26.1436 84.143H22.2796V89.732ZM44.6288 97.23C42.2828 97.23 40.5271 96.6167 39.3618 95.39C38.1965 94.148 37.6138 92.2313 37.6138 89.64C37.6138 86.9413 38.1965 84.9863 39.3618 83.775C40.5271 82.5637 42.2828 81.958 44.6288 81.958C46.9901 81.958 48.7458 82.5637 49.8958 83.775C51.0611 84.9863 51.6438 86.9413 51.6438 89.64C51.6438 92.2313 51.0611 94.148 49.8958 95.39C48.7458 96.6167 46.9901 97.23 44.6288 97.23ZM44.6288 95.114C46.1775 95.114 47.3121 94.6923 48.0328 93.849C48.7688 92.9903 49.1368 91.5873 49.1368 89.64C49.1368 87.5853 48.7688 86.1517 48.0328 85.339C47.3121 84.511 46.1775 84.097 44.6288 84.097C43.0955 84.097 41.9608 84.511 41.2248 85.339C40.5041 86.1517 40.1438 87.5853 40.1438 89.64C40.1438 91.5873 40.5041 92.9903 41.2248 93.849C41.9608 94.6923 43.0955 95.114 44.6288 95.114ZM60.7806 97L57.3306 82.188H59.7916L62.2986 93.297L65.1046 83.982V82.188H67.1516L70.3026 93.297L72.8556 82.188H75.2936L71.8666 97H69.4056L66.4386 86.627L63.2876 97H60.7806ZM82.3578 97V82.188H84.5658L92.2938 93.09V82.188H94.7778V97H92.5698L84.8648 86.121V97H82.3578Z",
    fill: "#8F8F8F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2_14)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46001 27.0513L48.5 48.5256L88.54 27.0513L77.3564 70H19.5333L8.46001 27.0513Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5 16.7436L75.8 70H21.2L48.5 16.7436Z",
    fill: "#535353",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64 21.8974C8.65032 21.8974 10.28 20.3591 10.28 18.4615C10.28 16.5639 8.65032 15.0256 6.64 15.0256C4.62968 15.0256 3 16.5639 3 18.4615C3 20.3591 4.62968 21.8974 6.64 21.8974Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5 9.8718C50.5103 9.8718 52.14 8.33349 52.14 6.4359C52.14 4.5383 50.5103 3 48.5 3C46.4897 3 44.86 4.5383 44.86 6.4359C44.86 8.33349 46.4897 9.8718 48.5 9.8718Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.36 21.8974C92.3703 21.8974 94 20.3591 94 18.4615C94 16.5639 92.3703 15.0256 90.36 15.0256C88.3497 15.0256 86.72 16.5639 86.72 18.4615C86.72 20.3591 88.3497 21.8974 90.36 21.8974Z",
    fill: "#8A8A8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_14",
    x: 0.988998,
    y: 81.958,
    width: 101.789,
    height: 22.272,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_14"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_14",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2_14",
    x: 3,
    y: 0,
    width: 106,
    height: 81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_14"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_14",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5a9e595384dbac71973bcb17a7e93556.svg";
export { ForwardRef as ReactComponent };